import React from "react";

import type { ServerDataSuccess } from "./route";

import {
  CarouselSection,
  Image,
  ImageModal,
  useModal,
  Zoomable,
  Carousel,
  CarouselControls,
  CarouselProvider,
  ContainerEscape,
} from "@bared/ui";

export interface AsSeenOnSectionProps {
  asSeenOnImages: ServerDataSuccess["asSeenOnImages"];
}

export function AsSeenOnSection(props: AsSeenOnSectionProps) {
  return (
    <div>
      <AsSeenOnContent {...props} />
      <Modal {...props} />
    </div>
  );
}

function AsSeenOnContent({ asSeenOnImages }: AsSeenOnSectionProps) {
  const { showModal } = useModal();
  const desktopSlidesPerView = asSeenOnImages.length < 5 ? "4" : "4.5";
  return (
    <>
      <CarouselProvider>
        <CarouselControls className="absolute right-mini" />
        <h4 className="font-display text-h4 text-primary">As Seen On</h4>
        <ContainerEscape config={{ default: "both", md: "both" }}>
          <Carousel
            ariaLabel="As seen on images"
            slidesPerView={{
              default: "1.5",
              md: "3.5",
              lg: desktopSlidesPerView,
            }}
            className="pt-midi"
          >
            {asSeenOnImages.map((image, index) => (
              <CarouselSection
                className="relative aspect-4-5 [&_img]:object-cover"
                index={index}
                key={`${index}-${image.alt}`}
                onClick={() =>
                  showModal("as-seen-on-modal", { initialIndex: index })
                }
              >
                <span className="absolute -left-[58px] top-[88px] z-10 w-exa rotate-90 text-left text-caption text-white">
                  {image.handle}
                </span>
                <Image
                  {...image}
                  sizes="100vw"
                  loading="eager"
                  aspectRatio="4/5"
                />
              </CarouselSection>
            ))}
          </Carousel>
        </ContainerEscape>
      </CarouselProvider>
    </>
  );
}

function Modal({ asSeenOnImages }: AsSeenOnSectionProps) {
  return (
    <ImageModal id="as-seen-on-modal" ariaLabel="As seen on images">
      {asSeenOnImages.map((image, index) => (
        <CarouselSection
          className="relative aspect-4-5"
          index={index}
          key={`${index}-${image.alt}`}
        >
          <Zoomable>
            <Image {...image} sizes="100vw" loading="eager" aspectRatio="4/5" />
          </Zoomable>
        </CarouselSection>
      ))}
    </ImageModal>
  );
}
